<template>
    <div class="detail-body">
        <div class="left-section" v-if="detData">
            <section class="section">
                <h2>
                    <img src="@/assets/home/icon3.png" alt="图标" class="section-icon" />
                    用户痛点
                </h2>
                <div class="point-refine-wrapper">
                    <div class="divider"></div>
                    <p class="tt">{{ detData.point }}</p>
                    <p><span class="leftFont">提炼：</span><span class="highlight">{{ detData.refine }}</span></p>
                </div>
            </section>
            <section class="section">
                <h2>
                    <img src="@/assets/home/icon1.png" alt="图标" class="section-icon" />
                    
                    <span style="white-space: nowrap;">解决方案</span>
                    <div class="solution-span">{{ detData.solution }}</div>
                </h2>
                <div class="point-refine-wrapper">
                    <div class="divider"></div>
                    <ul>
                        <li v-for="ii in detData.elementJsonArray" :key="ii.id"><span class="leftFont">{{ ii.name
                        }}：</span><span class="highlight">{{ ii.value }}</span></li>
                    </ul>
                </div>

            </section>
            <section class="section">
                <h2>
                    <img src="@/assets/home/icon2.png" alt="图标" class="section-icon" />
                    应用成效
                </h2>
                <div class="divider"></div>
                <p>{{ detData.effect }}</p>

                <!-- 图片轮播图开始 -->
                <div v-if="imgList.length" class="vertical-images">
                    <img v-for="(img, idx) in imgList" :key="idx" :src="img" alt="交通管理应用成效" class="image" />
                </div>
                <!-- 图片轮播图结束 -->
            </section>
        </div>
        <div class="right-section">
            <div class="more-solutions" @click="goBack">
                <span>更多解决方案</span>
                <img src="@/assets/home/daYu.png" alt="更多解决方案箭头" class="arrow" />
            </div>
            <div class="additional-content">
                <h2>相关使用产品</h2>
                <div v-for="(item, inex) in titleList" :key="inex" @click="handleProductClick(item)" class="pro_it"
                    :style="{ marginRight: inex === 0 ? '16PX' : '0' }">
                    <div class="imgGrop">
                        <img src="@/assets/home/移动航空站.png" :alt="item" class="product-image" v-if="item == '移动航空站'" />
                        <img src="@/assets/home/V140.png" :alt="item" class="product-image" v-if="item == '换电式自动机场'" />
                        <img src="@/assets/home/应急指挥车.png" :alt="item" class="product-image" v-if="item == '无人装备指挥车'" />
                        <img src="@/assets/home/D51.png" :alt="item" class="product-image"
                            v-if="item == '集群式换电航站'" />
                        <img src="@/assets/home/涡扇炮智能消防车@1x.png" :alt="item" class="product-image"
                            v-if="item == '陆空协同无人消防车'" />
                        <img src="@/assets/home/智能巡视机器人.png" :alt="item" class="product-image"
                            v-if="item == '陆空协同应急处置机器人'" />
                        <img src="@/assets/home/水上智能航空站.png" :alt="item" class="product-image" v-if="item == '海空协同无人船'" />
                        <img src="@/assets/home/VF7.png" :alt="item" class="product-image" v-if="item == '垂起固定翼机场'" />
                        <img src="https://hr2.chnsoft.com.cn/img/CGS-C03 集控飞行地面站.png" :alt="item" class="product-image" v-if="item == '无人装备便携地面站'" />
                        <img src="https://hr2.chnsoft.com.cn/img/CGS-100 集控飞行座舱.png" :alt="item" class="product-image" v-if="item == '无人装备驾控台'" />
                    </div>
                    <p>{{ item }}</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { IMG_BASE_URL } from '@/utils/index.js'; // 假设你在 config.js 里定义了 IMG_BASE_URL

export default {
    name: 'DetailBody',
    props: {
        detData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            currentImg: 0
        };
    },
    computed: {
        IMG_BASE_URL() {
            return IMG_BASE_URL;
        },
        imgList() {
            // detData.img 可能为 undefined/null
            if (!this.detData || !this.detData.img) return [];
            return this.detData.img.split(',').map(s => s.trim()).filter(Boolean);
        },
        titleList() {
            // 只有包含括号时才进行 split
            const title = this.detData.title || '';
            if (title.includes('（') && title.includes('）')) {
                return title.split('（')[1].split('）')[0].split('、');
            }
            return [];
        },
    },
    methods: {
        setProductLocalStorage(text) {
            if (text) {
                localStorage.setItem('selectedText', text);
                if (text == '海空协同无人船（艇）') {
                    localStorage.setItem('TeDianBgProName', '水上智能航空站');
                } else if (text == '陆空协同无人消防车') {
                    localStorage.setItem('TeDianBgProName', '陆空协同无人消防车');
                } else if (text == '算力服务器') {
                    localStorage.setItem('TeDianBgProName', 'ZF-C200 边缘计算终端');
                } else if (text == '机载板卡') {
                    localStorage.setItem('TeDianBgProName', 'ZF-A400 算力板卡');
                } else if (text == '系留供电装置') {
                    localStorage.setItem('TeDianBgProName', '系留供电装置');
                } else if (text == '无人装备便携地面站') {
                    localStorage.setItem('TeDianBgProName', '无人装备便携地面站');
                } else if (text == '机载任务系统') {
                    localStorage.setItem('TeDianBgProName', 'AMS-400-V112 机载任务系统');
                } else if (text == '无人装备驾控台') {
                    localStorage.setItem('TeDianBgProName', '无人装备驾控台');
                } else if (text == '智能全域巡视系统') {
                    localStorage.setItem('TeDianBgProName', '智能全域巡视系统');
                } else if (text == '全域电网巡检系统') {
                    localStorage.setItem('TeDianBgProName', '全域电网巡检系统');
                } else if (text == '垂起固定翼机场') {
                    localStorage.setItem('TeDianBgProName', '垂起固定翼机场');
                } else if (text == '换电式自动机场') {
                    localStorage.setItem('TeDianBgProName', '换电式自动机场');
                }
                else {
                    localStorage.setItem('TeDianBgProName', text);
                }
            }
        },
        handleProductClick(text) {
            localStorage.setItem('selectedText', text);
            this.setProductLocalStorage(text)
            let source = '';
            switch (text) {
                case '移动航空站':
                    source = 'product_lie_6';
                    break;
                case '换电式自动机场':
                    source = 'product_lie_2';
                    break;
                case '无人装备指挥车':
                    source = 'product_lie_7';
                    break;
                case '集群式换电航站':
                    source = 'product_lie_1';
                    break;
                case '无人驾驶消防车':
                    source = 'product_lie_8';
                    break;
                case '陆空协同无人消防车':
                    source = 'product_lie_8';
                    break;
                case '陆空协同应急处置机器人':
                    source = 'product_lie_9';
                    break;
                case '海空协同无人船（艇）':
                    source = 'product_lie_10';
                    break;
                case '垂起固定翼机场':
                    source = 'product_lie_4';
                    break;
                                    case '无人装备驾控台':
                    source = 'product_lie_17';
                    break;
                case '无人装备便携地面站':
                    source = 'product_lie_16';
                    break;
                            case "海空协同无人船":
          source = "product_lie_10";
          break;
            }
            this.$router.push({ path: '/product_lie', query: { source } });
        },
        goBack() {
            this.$router.push({ path: '/all_user_cases', query: { source: 'all_user_cases', navUserCaseType: 1 } });
            // this.$router ? this.$router.go(-1) : window.history.back();
        },
        prevImg() {
            if (this.currentImg > 0) {
                this.currentImg--;
            } else {
                this.currentImg = this.imgList.length - 1;
            }
        },
        nextImg() {
            if (this.currentImg < this.imgList.length - 1) {
                this.currentImg++;
            } else {
                this.currentImg = 0;
            }
        }
    },
    watch: {
        imgList() {
            // 切换数据时重置索引
            this.currentImg = 0;
        }
    }
};
</script>

<style lang="scss" scoped>
.detail-body {
    // display: flex;
    gap: 30PX;
    background: #FBFBFB;
    padding: 16PX;
    border: 1PX solid #ddd;
    padding-top: 20PX;

    .left-section {

        display: flex;
        flex-direction: column;
        gap: 16PX;
        margin-bottom: 16px;

        .section {
            background-color: #fff;
            border-radius: 4PX;
            padding: 16PX;
            // margin-bottom: 12PX;
            color: #1E242A;

            h2 {
                display: flex;
                align-items: center;
                font-size: 14PX;
                color: #1E242A;

                .section-icon {
                    width: 16PX;
                    height: 16PX;
                    margin-right: 8PX;
                    vertical-align: middle;
                }

                .solution-span {
                    font-family: PingFang SC;
                    font-size: 12PX;
                    font-weight: normal;
                    line-height: normal;
                    letter-spacing: 0PX;
                    font-variation-settings: "opsz" auto;
                    color: #1E242A;
                    opacity: 0.6;
                    margin-left: 8PX;
                }
            }

            .divider {
                height: 1PX;
                background: rgba(30, 36, 42, 0.1);
                margin: 12px 0;
            }

            .point-refine-wrapper {
                font-size: 12PX;
            }

            .tt {
                margin-bottom: 12PX;
                opacity: 1;

                font-family: PingFang SC;
                font-size: 12PX;
                font-weight: normal;
                line-height: normal;
                letter-spacing: 0PX;
                line-height: 1.5;
                font-variation-settings: "opsz" auto;
                color: #1E242A;
            }

            .leftFont {
                color: #1E242A;
            }

            .highlight {
                color: #1E242A;
                opacity: 0.6;
            }

            p {
                font-size: 12PX;
                line-height: 1.6;
                color: #1E242A;
            }

            ul {
                list-style: none;

                li {
                    font-size: 12PX;
                    line-height: 1.6;
                    color: #1E242A;
                    margin-bottom: 12PX;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }

            .image {
                width: 100%;
                height: 185PX;
                margin-top: 12PX;
                border-radius: 4PX;
                display: block;
                // margin-left: auto;
                // margin-right: auto;
                object-fit: cover;
            }

            .carousel {
                position: relative;
                width: 740PX;
                margin: 0 auto;

                .carousel-btn {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    background: rgba(255, 255, 255, 0.7);
                    border: none;
                    border-radius: 50%;
                    width: 32PX;
                    height: 32PX;
                    font-size: 20PX;
                    cursor: pointer;
                    z-index: 2;

                    &.left {
                        left: 0;
                    }

                    &.right {
                        right: 0;
                    }

                    &:disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                }

                .carousel-indicator {
                    display: flex;
                    justify-content: center;
                    margin-top: 8PX;

                    span {
                        display: inline-block;
                        width: 8PX;
                        height: 8PX;
                        border-radius: 50%;
                        background: #ccc;
                        margin: 0 3PX;

                        &.active {
                            background: #0f6bf6;
                        }
                    }
                }
            }
        }
    }

    .right-section {
        flex: 3;
        position: relative;

        border-radius: 4PX;

        h2 {
            font-size: 14PX;
            margin-bottom: 8PX;
            color: #1E242A;
        }

        .product-image {
            // position: absolute;
            // top: 50%;
            // left: 50%;
            // transform: translate(-50%, -50%);
            // z-index: 2;
            width: 100%;
            // max-width: 300PX;
            border-radius: 8PX;
        }

        .background-image {
            // position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 1;
            width: 100%;
            max-width: 320PX;
        }

        p {
            font-size: 12PX;
            font-weight: 600;
            color: #1E242A;
            text-align: center;
        }

        .more-solutions {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #fff;
            padding: 18PX 16PX;
            border-radius: 8PX;
            margin-top: 0PX;
            // box-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.1);
            margin-bottom: 20PX;
            cursor: pointer;

            span {
                font-weight: 600;
                font-size: 14PX;
                color: #1E242A;
            }

            img.arrow {
                width: 16PX;
                height: 16PX;
            }
        }

        .pro_it {
            width: calc(50% - 8px);
            display: inline-block;

            &:nth-child(1) {
                margin-right: 15PX;
            }

            &:nth-child(2n+1) {
                margin-right: 16px;
            }
        }



        .additional-content {
            border-radius: 8PX;
            background-color: #fff;
            // box-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.1);
            padding: 16PX;

            .imgGrop {
                position: relative;
                // height: 210PX;
                background: linear-gradient(1deg, #505761 0%, rgba(80, 87, 97, 0.3) 104%, rgba(28, 54, 93, 0) 104%);
                border-radius: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 16px;
                margin-bottom: 12px;
                cursor: pointer;
            }
        }
    }

    .vertical-images {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
</style>
